<template>
  <card>
    <list
      v-if="$store.state.user.sections['tickets']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="true"
      :setImport="true"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Номер: "id",
        Статус: "state_display",
        Ошибка: "name",
        "Время обработки (минуты)": "period",
        "Принял тикет": "start_by.name",
        "Закрыл тикет": "closed_by.name",

        Партнер: "partner.name",
        "Создатель тикета": "user.name",
        Проект: "info_project.title",
        // "Сервис ID": "model_id",
        Магазин: "shop.name",
        Категория: "ticket_rubric.name",
        "Дата создания": {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        "Дата начала обработки": {
          field: "start_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        "Дата закрытия": {
          field: "closed_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
      },
      staticFilters: [
        {
          title: "Фильтр по статусу",
          key: "state",
          default: "new",
          items: [
            {
              id: null,
              title: "Все",
            },
            {
              id: "new",
              title: "Новый",
            },
            {
              id: "proccess",
              title: "В процессе",
            },
            {
              id: "cancel",
              title: "Отменен",
            },
            {
              id: "done",
              title: "Выполнен",
            },
          ],
        },
        // {
        //   title: "Фильтр по сервису",
        //   key: "model_type",
        //   default: null,
        //   items: [
        //     {
        //       id: null,
        //       title: "Все",
        //     },
        //     {
        //       id: "subscription",
        //       title: "Смартфон по подписке",
        //     },
        //     {
        //       id: "order",
        //       title: "Заказы",
        //     },
        //   ],
        // },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "info_project",
          title: "Фильтр по проекту",
          titleKey: "info_project",
          field_key: "info_project",
          selectKey: "title",
        },
      ],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "info_project",
          labelKey: "project",
          label: "",
          type: "select-full",
          modal: "info_project",
          selectKey: "title",
        },
        {
          key: "name",
          col: "col-12",
          label: "Напишите проблему (Если заказ - укажите номер)",
          labelKey: "problem",
          type: "textarea",
        },

        {
          key: "media",
          col: "col-12",
          label: "Файл",
          labelKey: "file",
          type: "zip",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_ticket",
      itemLink: "tickets",
      setLink: "tickets",
      columns: [
        {
          detail: true,
          // remove: true,
        },
        {
          key: "id",
          title: "ID",
        },
        {
          key: "name",
          title: "Название",
        },

        {
          key: "info_project",
          title: "Проект",
          object: "title",
          disableLink: true,
          full: true,
        },
        {
          key: "state_display",
          title: "Статус",
          full: true,
        },

        {
          key: "created_at",
          title: "Дата создания",
          dateTimeFormat: true,
          full: true,
        },
        {
          key: "start_at",
          title: "Дата начала обработки",
          dateTimeFormat: true,
          full: true,
        },
        {
          key: "closed_at",
          title: "Дата закрытия",
          dateTimeFormat: true,
          full: true,
        },
        {
          key: "period",
          title: "Время обработки (мин.)",
        },

        {
          key: "start_by",
          title: "Принял тикет",
          object: "name",
          disableLink: true,
        },
        {
          key: "closed_by",
          title: "Закрыл тикет",
          object: "name",
          disableLink: true,
        },

        {
          key: "shop",
          title: "Магазин",
          object: "name",
          disableLink: true,
          full: true,
        },
        {
          key: "user",
          title: "Сотрудник",
          object: "name",
          disableLink: true,
          full: true,
        },

        {
          key: "model",
          object: "id",
          title: "ID Сервиса",
          disableLink: true,
        },
        {
          key: "model_user",
          title: "Создал заказ",
          object: "name",
          disableLink: true,
          full: true,
        },
        {
          key: "ticket_rubric",
          title: "Категория",
          object: "name",
          disableLink: true,
          full: true,
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
